
import { useState, useEffect, useRef } from "react";
import { useApi } from "../hooks/useApi";

export default function Settings() {
    const [settings, setSettings] = useState([]);

    const [name, setName] = useState("");
    const [value, setValue] = useState("");
    const initialized = useRef(false);
    const { apiCall } = useApi();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            apiCall(`get_all_settings`) // Update with your actual API endpoint
                .then(response => response.json())
                .then((data) => {
                    setSettings(data);
                }).finally(() => setLoading(false));
        }
    });
    async function addSetting() {
        if (!name.trim()) return;

        let newSetting = { setting: name.trim(), value: btoa(value) };
        let newSetting_local = { setting: name.trim(), value: value };
        try {
            const response = await apiCall(`update_setting`, {
                method: 'POST',
                body: newSetting
            });

            const result = await response.json();
            if (result.error) {
                throw new Error(result.error);
            }

            setSettings(prev => [...prev, newSetting_local]);
            setName("");
            setValue("");


        } catch (error) {
            alert(error.message);
        }
    }
    async function updateSetting(name) {
        if (!name) return;

        const value = settings.find(item => item.setting === name)?.value;
        let newSetting = { setting: name.trim(), value: btoa(value) };
        //let newSetting_local = { setting: name.trim(), value: value };
        try {
            const response = await apiCall(`update_setting`, {
                method: 'POST',
                body: newSetting
            });

            const result = await response.json();
            if (result.error) {
                throw new Error(result.error);
            }

            //setSettings(prev => [...prev, newSetting_local]);

            alert('Saved');
        } catch (error) {
            alert(error.message);
        }
    }
    async function deleteSetting(setting) {
        if (!window.confirm("Are you sure you want to delete this setting?")) {
            return;
        }

        let setting_to_remove = { setting: setting };
        try {
            const response = await apiCall(`delete_setting`, {
                method: 'POST',
                body: setting_to_remove
            });

            const result = await response.json();
            if (result.error) {
                throw new Error(result.error);
            }

            setSettings(settings.filter((item) => item.setting !== setting));

        } catch (error) {
            alert(error.message);
        }

    }

    function updateValue(setting, newValue) {
        setSettings((prev) =>
            prev.map((item) =>
                item.setting === setting ? { ...item, value: newValue } : item
            )
        );
    }
    if (loading) return 'Loading...';
    return (
        <div style={{ maxWidth: 1200, margin: "40px auto", padding: 20 }}>
            <h1 className="text-2xl font-bold mb-4">Settings</h1>

            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: 24,
                }}
            >
                <thead>
                    <tr>
                        {["Setting", "Value", "Action"].map((heading) => (
                            <th
                                key={heading}
                                width={heading === 'Value' ? "50%" : '20%'}
                                style={{
                                    textAlign: "left",
                                    padding: 12,
                                    borderBottom: "2px solid #ddd",
                                }}
                            >
                                {heading}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {settings.filter(item => item.setting !== 'deadline').map((item) => (
                        <tr key={item.setting}>
                            <td style={cell}>{item.setting}</td>
                            <td style={cell}>
                                <input
                                    value={item.value ?? ''}
                                    onChange={(e) =>
                                        updateValue(item.setting, e.target.value)
                                    }
                                    style={{ width: "100%", padding: 7 }}
                                />
                            </td>
                            <td style={cell}>
                                <button className="disabled:bg-gray-300 disabled:cursor-auto px-3 py-2 bg-amber-300 text-white cursor-pointer"
                                    disabled={item.setting === 'deadline'}
                                    onClick={() => deleteSetting(item.setting)}

                                >
                                    Delete
                                </button>
                                <button className="ml-4 disabled:bg-gray-300 disabled:cursor-auto px-3 py-2 bg-green-500 text-white cursor-pointer"
                                    disabled={item.setting === 'deadline'}
                                    onClick={(e) => updateSetting(item.setting)}

                                >
                                    Update
                                </button>
                            </td>
                        </tr>
                    ))}

                    {settings.length === 0 && (
                        <tr>
                            <td colSpan="4" style={cell}>
                                No settings found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <h3>Add Setting</h3>

            <div style={{ display: "flex", gap: 10 }}>
                <input
                    placeholder="Setting name"
                    value={name}
                    className="border"
                    onChange={(e) => setName(e.target.value)}
                    style={{ flex: 1, padding: 10 }}
                />

                <input
                    placeholder="Value"
                    value={value}
                    className="border"
                    onChange={(e) => setValue(e.target.value)}
                    style={{ flex: 2, padding: 10 }}
                />

                <button onClick={addSetting} className="px-3 py-2 bg-blue-600 text-white cursor-pointer">
                    Add Setting
                </button>
            </div>
        </div>
    );
}

const cell = {
    padding: 12,
    borderBottom: "1px solid #ddd",
    textAlign: "left",
};